<p class="error-text" @showError *ngIf="errorMessage !== null">{{ errorMessage }}</p>
